import { render } from "./ModalHelp.vue?vue&type=template&id=eb9be1c0"
import script from "./ModalHelp.vue?vue&type=script&lang=js"
export * from "./ModalHelp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__